<template>
  <article class="area-service">
    <h2 @click="toToggleShow">
      <p>服务区域</p>
      <div :class="{ isShowAll: isShowAreaAll }">
        <div class="areas">
          <span v-show="!isShowAreaAll">{{
            toSearchAreasStrUp(schedualAreasStr)
          }}</span>
        </div>
        <i></i>
      </div>
    </h2>
    <section v-show="isShowAreaAll">
      <p v-for="areas in toSearchAreasStr(schedualAreasStr)">{{ areas }}</p>
    </section>
  </article>
</template>
<script>
export default {
  props: ['schedualAreasStr'],
  data() {
    return {
      isShowAreaAll: false
    }
  },
  methods: {
    toSearchAreasStr(arr) {
      return arr && arr.map(item => item.replace(/\./g, ' '))
    },
    toSearchAreasStrUp(arr) {
      return arr && arr.length > 0
        ? arr
            .reduce((pre, curr) => `${pre}.${curr}`)
            .split('.')
            .filter((e, i) => i < 4)
            .join(' · ')
        : ''
    },
    toToggleShow() {
      this.isShowAreaAll = !this.isShowAreaAll
    }
  }
}
</script>
<style lang="scss" scoped>
@import '../../assets/css/mixin';
.area-service {
  margin-top: rem(24px);
  padding-top: rem(24px);
  margin-bottom: rem(6px);
  @include border(top, #e8e8e8);
  h2 {
    display: flex;
    align-items: center;
    justify-content: space-between;

    > p {
      background: url('~@/assets/images/icon-yues-location@3x.png') no-repeat
        left center;
      background-size: rem(24px) auto;
      padding-left: rem(31px);
      font-size: rem(26px);
      color: #333;
      height: rem(32px);
      font-weight: 600;
    }
    > div {
      height: rem(32px);
      display: flex;
      align-items: center;
      width: rem(530px);
      justify-content: flex-end;
      .areas {
        width: rem(400px);
        @include ellicpsis;
        text-align: right;
        padding-right: rem(12px);

        font-size: rem(26px);
        color: #666666;
        line-height: rem(32px);
      }
      i {
        height: 100%;
        display: inline-block;
        width: rem(20px);
        background-repeat: no-repeat;
        background-image: url('~@/assets/images/icon_down@3x.png');
        background-size: 100% auto;
        background-position: right center;
      }
      &.isShowAll {
        i {
          background-image: url('~@/assets/images/icon_up@3x.png');
        }
      }
    }
  }
  section {
    margin-top: rem(16px);
    font-size: rem(26px);
    color: #666666;
    line-height: rem(40px);
    padding-left: rem(31px);
  }
}
</style>
